<!-- <app-pre-loader *ngIf="loadingBar !== undefined && +(loadingBar.progress$|async) > 0"></app-pre-loader> -->

<header id="header">
  <div id="header-wrap">
    <div>
      <div class="row vertical-center height-90 max-width-1500" [ngClass]="{'qp11-dark-top-max-width': isQP11Dark}">
        <!----LOGO---->
        <div class="col-2 p-l-0">

          <!----SEASONAL THEME LOGO---->
          <!-- <ng-container *ngIf="showTheme; else noTheme">
            <ng-container *ngFor="let theme of themes | keyvalue: returnZero">
                <a *ngIf="theme.value.started && !theme.value.end" routerLink="/">
                  <div class="main-logo-topbar christmas cny mid-autumn"></div>
                </a>
            </ng-container>
          </ng-container> -->

          <!----NORMAL LOGO---->
          <!-- <ng-template #noTheme>
            <a routerLink="/" data-dark-logo="/assets/images/logo-dark.png">
              <div class="main-logo-topbar"></div>
            </a>
          </ng-template> -->

          <!-- LOGO GET FROM DB AND WITHOUT HARDCODED SESONAL THEME-->
          <a routerLink="/home">
            <div *ngIf="!logoLoading" class="main-logo-topbar" [style.backgroundImage]="'url(' + logoUrl + ')'"></div>
          </a>

          <div *ngIf="logoLoading" class="skeleton skeleton-logo w-100"></div>

        </div>
        <div class="col-10 p-r-0">
          <nav class="primary-menu order-lg-3 px-0">
            <ul class="menu-container justify-content-lg-end">
              <!-- Superseded by the .refresh-wrapper banner below (same as template-02): one
                   update affordance, not two. Kept for reference until the banner has shipped. -->
              <!-- <li class="menu-item m-r-10 c-pointer position-relative" [hidden]="!haveNewVersion" (click)="onShowReloadModal()">
                <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M30.6214 17.4963C30.6247 19.7564 30.0392 21.9785 28.9225 23.9435L27.2775 22.2985C27.0735 22.0947 26.8137 21.9558 26.5308 21.8996C26.248 21.8433 25.9548 21.8722 25.6884 21.9826C25.4219 22.0929 25.1942 22.2798 25.0339 22.5195C24.8737 22.7593 24.7881 23.0412 24.7881 23.3296L24.7881 29.1629C24.7881 29.5497 24.9417 29.9206 25.2152 30.1941C25.4887 30.4676 25.8596 30.6213 26.2464 30.6213L32.0797 30.6213C32.3681 30.6212 32.65 30.5356 32.8898 30.3754C33.1296 30.2151 33.3164 29.9874 33.4268 29.721C33.5371 29.4545 33.566 29.1614 33.5098 28.8785C33.4535 28.5957 33.3147 28.3358 33.1108 28.1319L31.0589 26.0756C32.5949 23.6489 33.4512 20.8544 33.5385 17.9838C33.6258 15.1132 32.9408 12.2718 31.5551 9.75631C30.1695 7.24079 28.1339 5.14339 25.6609 3.6831C23.188 2.22281 20.3683 1.45319 17.4964 1.45459C17.1096 1.45459 16.7387 1.60824 16.4652 1.88173C16.1917 2.15522 16.0381 2.52615 16.0381 2.91292C16.0381 3.2997 16.1917 3.67063 16.4652 3.94412C16.7387 4.21761 17.1096 4.37126 17.4964 4.37126C20.9762 4.37512 24.3123 5.75917 26.7729 8.21974C29.2335 10.6803 30.6176 14.0165 30.6214 17.4963Z" fill="#494E60"/>
                  <path d="M18.9541 32.0794C18.9541 31.6927 18.8005 31.3217 18.527 31.0482C18.2535 30.7747 17.8825 30.6211 17.4958 30.6211C14.016 30.6172 10.6798 29.2332 8.21925 26.7726C5.75868 24.312 4.37463 20.9759 4.37077 17.4961C4.36671 15.2361 4.95285 13.0142 6.07119 11.0503L7.71473 12.6938C7.91868 12.8977 8.1785 13.0365 8.46135 13.0928C8.74419 13.149 9.03737 13.1201 9.30381 13.0098C9.57024 12.8994 9.79798 12.7126 9.95823 12.4728C10.1185 12.233 10.204 11.9511 10.2041 11.6628L10.2041 5.82943C10.2041 5.44265 10.0505 5.07172 9.77697 4.79823C9.50348 4.52474 9.13254 4.37109 8.74577 4.37109L2.91244 4.37109C2.62403 4.37102 2.34207 4.45647 2.10222 4.61663C1.86237 4.77679 1.6754 5.00447 1.56494 5.27088C1.49117 5.44783 1.45348 5.63772 1.4541 5.82943C1.45419 6.21617 1.60788 6.58704 1.88139 6.86047L3.93327 8.91818C2.3043 11.4819 1.44396 14.4586 1.4541 17.4961C1.45912 21.7491 3.15083 25.8264 6.15814 28.8337C9.16545 31.841 13.2428 33.5327 17.4958 33.5378C17.8825 33.5378 18.2535 33.3841 18.527 33.1106C18.8005 32.8371 18.9541 32.4662 18.9541 32.0794Z" fill="#494E60"/>
                  <path d="M15.9603 19.9968L15.237 9.3335H19.577L18.8537 19.9968H15.9603ZM17.407 25.8535C16.7537 25.8535 16.217 25.6435 15.797 25.2235C15.377 24.8035 15.167 24.3057 15.167 23.7302C15.167 23.1391 15.377 22.6491 15.797 22.2602C16.217 21.8557 16.7537 21.6535 17.407 21.6535C18.0759 21.6535 18.6125 21.8557 19.017 22.2602C19.437 22.6491 19.647 23.1391 19.647 23.7302C19.647 24.3057 19.437 24.8035 19.017 25.2235C18.6125 25.6435 18.0759 25.8535 17.407 25.8535Z" fill="#494E60"/>
                </svg>
                <span class="red-dot"></span>
              </li> -->

              <!-- isBrowser guard: the server cannot know the session, so render neither the
                   logged-out nor the member block there; the client draws the correct one. -->
              <ng-container *ngIf="isBrowser">
              <ng-container *ngIf="!(isLoggedIn$ | async) && !hasStoredSession; else elseMember">
                <li class="menu-item m-r-10">
                  <button class="main-button-2" (click)="onOpenDialog('login')">
                    {{ 'Login' | translate | uppercase}}
                  </button>
                </li>
                <li class="menu-item">
                  <button class="main-button-1 h-35 main-button-5" (click)="onOpenDialog('signup')">
                    {{ 'Register' | translate | uppercase }}
                  </button>
                </li>
                <li class="menu-item languages-selection">
                  <a (click)="onOpenDialog('language')">
                    <img [src]="userFlag" width="25px" (error)="onFlagError($event)">
                    {{ currentLangCode }}
                  </a>
                </li>
              </ng-container>
              </ng-container>

              <ng-template #elseMember>
                <li class="menu-item m-r-10 menu-wallet-link d-flex">
                  <div [ngClass]="sitePrefix + '-env'" *ngIf="isQP2">
                    <div id="fasttrack-crm"></div>
                    <a class="menu-item fast-track-btn menu-wallet-link" onclick="window.FasttrackCrm.toggleInbox();">
                      <span class="notification-counter-wrapper">
                        FAST TRACK <span id="ft-crm-inbox-badge" class="badge badge-danger">0</span>
                      </span>
                    </a>
                  </div>
                  <!-- <div [ngClass]="sitePrefix + '-env'">
                    <a onclick="window.FasttrackCrm.toggleInbox();">
                      <div id="fasttrack-crm"></div>
                      <span class="notification-counter-wrapper">
                        FAST TRACK <span id="ft-crm-inbox-badge" class="badge badge-danger">0</span>
                      </span>
                    </a>
                  </div> -->
                  <a routerLink="/member/message">{{ 'Message' | translate | uppercase }}<span class="notification-counter-wrapper">
                      <ng-container *ngIf="(isLoggedIn$ | async)">
                        <ng-container *ngIf="(unreadMessages$ | async) as unreadMessages">
                          <span class="badge badge-danger" *ngIf="unreadMessages >= 1">{{ unreadMessages }}</span>
                        </ng-container>
                      </ng-container>
                    </span></a>
                  <a routerLink="/member/profile">{{ 'My Profile' | translate | uppercase }}</a>
                  <a (click)="onLogout()">{{ 'Logout' | translate | uppercase }}</a>
                </li>
                <ng-container *ngIf="userProfileDetail">
                  <li class="welcome-text menu-item">
                    <div class="welcome-container">
                      <img [src]="userProfileDetail.member_group?.group_icon" 
                          [alt]="userProfileDetail.member_group?.name + ' Badge Icon'" 
                          *ngIf="userProfileDetail.member_group?.group_icon"
                          class="group-icon-large">
                      
                      <div class="welcome-content">
                        <p class="username-line">
                          <span class="username">{{ userProfileDetail.username ? userProfileDetail.username : userData.username }}</span>
                          <span class="member-group-name" *ngIf="userProfileDetail.member_group?.name">| {{ userProfileDetail.member_group.name }}</span>
                        </p>
                        
                        <p *ngIf="!isReload" class="balance-line">
                          {{ memberCurrency }} {{ memberBalance | number : '1.2-2' | amountFormat }}
                          <span [innerHTML]="svg.refreshIcon | safeHtml" (click)="onRestore()"></span>
                        </p>
                        
                        <div *ngIf="isReload" class="skeleton skeleton-wallet-amount w-100"></div>
                      </div>
                    </div>
                  </li>
                </ng-container>
                <li class="menu-item" style="position: relative">
                  <span *ngIf="depositData != null" class="badge-btn top-bar-badge no-content-badge" matBadge="-" matBadgeColor="warn"></span>
                  <div class="depositImage" (click)="onRedirectDeposit()" [innerHTML]="(this.projectCode == 'qp15' ? svg.walletWithDepositIcon : svg.walletIcon) | safeHtml">
                  </div>
                </li>
                  <li class="turnover-text menu-item">
                      <ng-container *ngIf="turnoverAmount !== undefined && !isReload">
                        <p *ngIf="(turnoverAmount.total_promo_turnover>0 || turnoverAmount.total_deposit_turnover>0); else no_turnover">
                          {{ 'Turnover' | translate | uppercase }}
                          <span>
                            <ng-container *ngIf="isDepositTurnover">
                             &nbsp;<i class="fa fa-info-circle turnover-tooltip-icon" ></i>&nbsp;
                              <table class="turnover-tooltip">
                                <tr>
                                  <td colspan="2" class="turnover-text-title">
                                    {{ 'Turnover Breakdown' | translate | uppercase }}
                                  </td>
                                </tr>
                            
                                <tr>
                                  <td class="p-t-10">
                                    {{ 'Promotion Turnover' | translate | titlecase }}
                                  </td>
                                  <td class="p-t-10">
                                    {{ turnoverAmount.accumulated_promo_turnover | number : '1.2-2' | amountFormat }} / {{ turnoverAmount.total_promo_turnover | number : '1.2-2' | amountFormat }}
                                  </td>
                                </tr>
                            
                                <tr>
                                  <td class="p-b-10">
                                    {{ 'Deposit Turnover' | translate | titlecase }}
                                  </td>
                                  <td class="p-b-10">
                                    {{ turnoverAmount.accumulated_deposit_turnover | number : '1.2-2' | amountFormat }} / {{turnoverAmount.total_deposit_turnover | number : '1.2-2' | amountFormat }}
                                  </td>
                                </tr>
                            
                                <tr>
                                  <td>
                                    {{ 'Turnover Needed to Unlock' | translate | titlecase }}
                                  </td>
                                  <td>
                                    {{ (show_promo_turnover? turnoverAmount.accumulated_promo_turnover: turnoverAmount.accumulated_deposit_turnover) | number : '1.2-2' | amountFormat }} 
                                    / 
                                    {{ (show_promo_turnover? turnoverAmount.total_promo_turnover: turnoverAmount.total_deposit_turnover) | number : '1.2-2' | amountFormat }}
                                  </td>
                                </tr>
                              </table>   
                            </ng-container>                          
                            {{ (!show_promo_turnover && isDepositTurnover? turnoverAmount.accumulated_deposit_turnover: turnoverAmount.accumulated_promo_turnover) | number : '1.2-2' | amountFormat }} 
                            / 
                            {{ (!show_promo_turnover && isDepositTurnover? turnoverAmount.total_deposit_turnover: turnoverAmount.total_promo_turnover) | number : '1.2-2' | amountFormat }}                          
                          </span>
                        </p>

                        <ng-template #no_turnover>
                          <p>
                            {{ 'Turnover' | translate | uppercase }}
                            <span>
                              {{ '0' | number : '1.2-2' | amountFormat }} 
                                / 
                              {{ '0' | number : '1.2-2' | amountFormat }}  
                            </span> 
                          </p>                       
                        </ng-template>

                        <p *ngIf="turnoverAmount.total_promo_winover > 0">
                          {{ 'Winover' | translate | uppercase }} <span>{{turnoverAmount.accumulated_promo_winover | number : '1.2-2' | amountFormat }} / {{turnoverAmount.total_promo_winover | number : '1.2-2' | amountFormat }}</span>
                        </p>
                      </ng-container>
                      <!-- <span *ngIf="isReload" class="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span> -->
                  </li>
                  <div *ngIf="isReload" class="skeleton skeleton-turnover"></div>
                <li class="menu-item languages-selection p-r-0"><a (click)="onOpenDialog('language')"><img [src]="userFlag" (error)="onFlagError($event)">{{ currentLangCode }}</a></li>
              </ng-template>

            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <div id="top-bar-menu" class="top-nav" [ngClass]="fixed ? 'position-fixed' : 'position-absolute'">
    <div class="top-navigation-bar">
      <div class="row vertical-center height-50 max-width-1500 space-between" [ngClass]="{'qp11-dark-header-container': isQP11Dark}">
        <ul class="flex-container w-100 navigation-menu">
          <li class="menu-item">
            <div class="device-switch p-r-20">
              <a routerLink="/home" routerLinkActive="current"
                (mouseenter)="onHover('home', true)" (mouseleave)="onHover('home')" [innerHTML]="svg.desktopIcon | safeHtml">
              </a>
            </div>
          </li>

          <div class="swiper" appSwiper [config]="menuBarConfig" #menubars style="width: 90%" id="menubars">
            <div class="swiper-wrapper">
              <ng-container *ngIf="menu !== null && !isSkeletonMenuLists; else skeletonMenuLists">
                <ng-container *ngFor="let menuList of menu">
                  <ng-container *ngIf="menuList.link != null; else emptyMenu">
                    <ng-container *ngIf="!['/casino', '/casino-game','/slots', '/slots-game', '/fishing', '/sports', '/esports', '/cock-fighting', '/crickets', '/lottery', '/poker', '/crash-game', '/table', '/arcade'].includes(getRouterLink(menuList.link)); else gameMenu">
                      <ng-container *ngIf="!menuList.link.startsWith('#/popup/'); else popupMenu">
                        <div class="swiper-slide">
                          <li [ngClass]="{'current': checkActiveRoute(menuList.link)}">
                            <a (click)="navigateTo(menuList.link)">
                              <div class="text-center menu-text">{{ menuList.name }}</div>
                            </a>
                          </li>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #gameMenu>
                    <div class="swiper-slide" *ngIf="availableProvider !== null && (getRouterLink(menuList.link) == '/casino' &&  availableProvider.LC?.length > 0) 
                                                                                || (getRouterLink(menuList.link) == '/casino-game' &&  availableProvider.LC?.length > 0)
                                                                                || (getRouterLink(menuList.link) == '/slots-game' && availableProvider.SL?.length > 0)
                                                                                || (getRouterLink(menuList.link) == '/slots' && availableProvider.SL?.length > 0) || (getRouterLink(menuList.link) == '/fishing' &&  availableProvider.FS?.length > 0) || (getRouterLink(menuList.link) == '/sports' && availableProvider.SP?.length > 0) 
                                                                                || (getRouterLink(menuList.link) == '/esports' &&  availableProvider.ES?.length > 0) || (getRouterLink(menuList.link) == '/cock-fighting' &&  availableProvider.CF?.length > 0) || (getRouterLink(menuList.link) == '/crickets' &&  availableProvider.CK?.length > 0) || (getRouterLink(menuList.link) == '/lottery' &&  availableProvider.LT?.length > 0)
                                                                                || (getRouterLink(menuList.link) == '/crash-game' &&  availableProvider.CG?.length > 0) || (getRouterLink(menuList.link) == '/poker' &&  availableProvider.PK?.length > 0) || (getRouterLink(menuList.link) == '/table' &&  availableProvider.TB?.length > 0) || (getRouterLink(menuList.link) == '/arcade' &&  availableProvider.AR?.length > 0)">
                      <li [class]="isRouteActive(menuList.link) ? 'current' : ''">
                        <a [routerLink]="getRouterLinkWithGameProvider(menuList.link)">
                          <div class="text-center menu-text">{{ menuList.name }}</div>
                        </a>
                      </li>
                    </div>
                  </ng-template>

                  <ng-template #popupMenu>
                    <div class="swiper-slide">
                      <li>
                        <a (click)="onOpenDialog(menuList.link.substring(menuList.link.indexOf('#/popup/') + '#/popup/'.length))">
                          <div class="text-center menu-text">{{ menuList.name }}</div>
                        </a>
                      </li>
                    </div>
                  </ng-template>

                  <ng-template #emptyMenu>
                    <div class="swiper-slide">
                      <li>
                        <a>
                          <div class="text-center menu-text">{{ menuList.name }}</div>
                        </a>
                      </li>
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container *ngIf="moreItems !== null && moreItems.length > 0">
                  <div class="swiper-slide">
                    <li>
                      <a>
                        <div class="text-center menu-text" mat-icon-button [matMenuTriggerFor]="menu" aria-label="more menu" id="more-button">
                            {{ 'More' | translate | uppercase }}<i class="fa fa-caret-down pl-2" [ngClass]="{'flip-180': flipArrow()}"></i>
                        </div>
                      </a>
                      <mat-menu #menu="matMenu" class="custom-more-menu" xPosition="after" yPosition="below">
                        <ng-container *ngFor="let moreList of moreItems">
                              <ng-container *ngIf="!['/casino', '/slots', '/fishing', '/sports', '/esports', '/cock-fighting', '/crickets', '/lottery', '/poker', '/crash-game', '/table', '/arcade'].includes(getRouterLink(moreList.link)); else gameMoreMenu">
                                <ng-container *ngIf="!moreList.link.startsWith('#/popup/'); else popupMoreMenu">
                                    <li mat-menu-item [ngClass]="{'current': checkActiveRoute(moreList.link)}">
                                      <a (click)="navigateTo(moreList.link)">
                                        <div class="text-center menu-text">{{ moreList.name }}</div>
                                      </a>
                                    </li>
                                </ng-container>
                              </ng-container>
                            <ng-template #gameMoreMenu>
                              <ng-container *ngIf="availableProvider !== null && (getRouterLink(moreList.link) == '/casino' &&  availableProvider.LC?.length > 0) || (getRouterLink(moreList.link) == '/slots' && availableProvider.SL?.length > 0) || (getRouterLink(moreList.link) == '/fishing' &&  availableProvider.FS?.length > 0) || (getRouterLink(moreList.link) == '/sports' && availableProvider.SP?.length > 0) 
                                                                                          || (getRouterLink(moreList.link) == '/esports' &&  availableProvider.ES?.length > 0) || (getRouterLink(moreList.link) == '/cock-fighting' &&  availableProvider.CF?.length > 0) || (getRouterLink(moreList.link) == '/crickets' &&  availableProvider.CK?.length > 0) || (getRouterLink(moreList.link) == '/lottery' &&  availableProvider.LT?.length > 0)
                                                                                          || (getRouterLink(moreList.link) == '/crash-game' &&  availableProvider.CG?.length > 0) || (getRouterLink(moreList.link) == '/poker' &&  availableProvider.PK?.length > 0) || (getRouterLink(moreList.link) == '/table' &&  availableProvider.TB?.length > 0) || (getRouterLink(moreList.link) == '/arcade' &&  availableProvider.AR?.length > 0)">
                                <li mat-menu-item [class]="isRouteActive(moreList.link) ? 'current' : ''">
                                  <a [routerLink]="getRouterLinkWithGameProvider(moreList.link)">
                                    <div class="text-center menu-text">{{ moreList.name }}</div>
                                  </a>
                                </li>
                              </ng-container>
                            </ng-template>
          
                            <ng-template #popupMoreMenu>
                                <li mat-menu-item>
                                  <a (click)="onOpenDialog(moreList.link.substring(moreList.link.indexOf('#/popup/') + '#/popup/'.length))">
                                    <div class="text-center menu-text">{{ moreList.name }}</div>
                                  </a>
                                </li>
                            </ng-template>
                        </ng-container>
                      </mat-menu>
                    </li>
                  </div>
                </ng-container>
              </ng-container>
            </div>   
          </div>

          <!-- Skeleton Loading -->
          <ng-template #skeletonMenuLists>
            <ng-container *ngIf="isSkeletonMenuLists">
              <ng-container *ngFor="let item of [].constructor(8); let i = index">
                <li class="no-background m-auto">
                  <a>
                    <p class="skeleton skeleton-text m-auto w-50"></p>
                  </a>
                </li>
              </ng-container>
            </ng-container>
          </ng-template>
          <!-- <li routerLinkActive="current">
            <a routerLink="/home">
              <div>{{ 'Leaderboard' | translate }}</div>
            </a>
          </li> -->
        </ul>
      </div>
    </div>

    <div class="refresh-wrapper" [hidden]="!haveNewVersion">
      <div class="refresh-container">
        <div class="row justify-content-center pl-4 pr-4">
          <p class="text-center mb-0 align-items-center d-flex p-5 mr-3">{{ 'A new update is ready. Please update to keep playing.' | translate }}</p>
          <button class="main-button-1 h-35 main-button-5 refresh-ui-btn mr-3" (click)="updateAppInterface()">{{ 'Refresh Now' | translate }}</button>
          <button class="h-35 refresh-ui-btn skip-refresh-btn" (click)="haveNewVersion = false">&#x2716;</button>
        </div>
      </div>
    </div>
    <!-- <ng-container *ngIf="showKYCGateKeeper && memberKYC">
      <div *ngIf="memberKYC !== 'pro'" class="top-navigation-bar d-flex justify-content-center gate-keeper-top-bar">
        <div class="row vertical-center  height-50 max-width-1500">
          <a routerLink="/member/profile">
            {{ 'This feature is only available on Pro account.' | translate }}
            {{ 'Verify now to unlock!' | translate }}
          </a>
        </div>
      </div>
    </ng-container> -->
  </div>
</header>